import axios, { AxiosInstance, AxiosError, InternalAxiosRequestConfig } from 'axios';

import { getApiBaseUrl, getSkipLegacySession } from '../config/runtimeConfig';

export const apiClient: AxiosInstance = axios.create({
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Needed for session cookie (sessionid) from Apigee
});

// Request interceptor
apiClient.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    config.baseURL = getApiBaseUrl();
    if (getSkipLegacySession()) {
      config.headers['X-Legacy'] = 'false';
    }
    if (__DEV__) {
      console.log('[API Request]', {
        method: config.method?.toUpperCase(),
        url: config.url,
        data: config.data,
      });
    }

    return config;
  },
  (error: AxiosError) => {
    console.error('[API Request Error]', error);
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    if (__DEV__) {
      console.log('[API Response]', {
        status: response.status,
        url: response.config.url,
        data: response.data,
      });
    }

    return response;
  },
  (error: AxiosError) => {
    if (__DEV__) {
      console.error('[API Response Error]', {
        status: error.response?.status,
        url: error.config?.url,
        data: error.response?.data,
        message: error.message,
      });
    }

    return Promise.reject(error);
  }
);
